import {
  Component,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  HostListener,
  ElementRef,
  Input,
  ViewChild,
  ViewChildren,
  QueryList,
  OnInit,
  OnDestroy,
  ViewEncapsulation,
  TemplateRef,
  ChangeDetectorRef
} from '@angular/core';

import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { Subject } from 'rxjs';
import { FilterBuilderFilter, FilterBuilderOutput, FilterBuilderParam, FilterBuilderParamOpt, FilterValueTransformFunction, SearchFilterBuilderOutput } from 'src/app/models/filter-builder';
import { ItemSearchOptionField, ItemSearchOptionFieldOption } from '../../filter-list/models/filterClasses';
import { WorkflowApplicationsJanusService } from 'src/app/views/admin/workflow-applications/workflow-applications-janus/workflow-applications-janus.service';
import { myWorkOptions } from './common-filterbuilder-staff-janus.model';
// added by priya 27-02-2026
const defaultTransforms: {
  [inputType: string]: FilterValueTransformFunction;
} = {
  date: (value: string) => {
    if (!value) {
      return '(unset)';
    }
    return moment(value).format('MM/DD/YYYY');
  },
  ['datetime-local']: (value: string) => {
    if (!value) {
      return '(unset)';
    }
    return moment(value).format('MM/DD/YYYY h:mm a');
  }
};
// end by priya 27-02-2026


@Component({
  selector: 'app-common-filterbuilder-staff-janus',
  standalone: false,
  templateUrl: './common-filterbuilder-staff-janus.component.html',
  styleUrls: ['./common-filterbuilder-staff-janus.component.scss']
})
// export class CommonFilterbuilderStaffJanusComponent {
export class CommonFilterbuilderStaffJanusComponent implements OnChanges, OnInit, OnDestroy {
  constructor(
    private elementRef: ElementRef,
    private workflowApplicationsJanusSvc: WorkflowApplicationsJanusService,
    private cdr: ChangeDetectorRef
  ) { }

  isFilterDrawerOpen = false;
filterDrawerType: 'attribute' | 'mywork' | 'bulk' = 'attribute';
isMobileView = window.innerWidth <= 959;

private mobileFilterDrawerElement: HTMLElement | null = null;

// Render the responsive drawer at document level so page headers and transformed
// content containers cannot create a stacking context above it.
@ViewChild('mobileFilterDrawer')
set mobileFilterDrawer(element: ElementRef<HTMLElement> | undefined) {
  if (!element) {
    this.mobileFilterDrawerElement = null;
    document.body.classList.remove('common-filter-mobile-drawer-open');
    return;
  }

  this.mobileFilterDrawerElement = element.nativeElement;
  if (this.mobileFilterDrawerElement.parentElement !== document.body) {
    document.body.appendChild(this.mobileFilterDrawerElement);
  }
  document.body.classList.add('common-filter-mobile-drawer-open');
}

@HostListener('window:resize')
onResize() {
  const wasMobileView = this.isMobileView;
  this.isMobileView = window.innerWidth <= 959;

  if (wasMobileView !== this.isMobileView) {
    this.filterPopover?.close();
    this.filterPopovers?.forEach(popover => popover.close());
    this.closeMobileFilterDrawer();
  }

  this.updateDropdownHeight();
}
openMobileFilterDrawer(type: 'attribute' | 'mywork' | 'bulk') {
  this.filterPopover?.close();
  this.filterPopovers?.forEach(popover => popover.close());
  this.closeAll();
  this.filterDrawerType = type;
  this.isFilterDrawerOpen = true;
  if (type === 'attribute') {
    this.attributeMenuOpened.emit();
  }
}

closeMobileFilterDrawer() {
  this.isFilterDrawerOpen = false;
  document.body.classList.remove('common-filter-mobile-drawer-open');
}

ngOnDestroy() {
  document.body.classList.remove('common-filter-mobile-drawer-open');
  this.mobileFilterDrawerElement?.remove();
  this.mobileFilterDrawerElement = null;
}

  private isInitialLoad = true;

  @Input() useMuiLayout: boolean = false;
  @Input({required:false}) allowTransformFilterValue: boolean = true;

  @Input() hideAttributeButton = false;
  @Input() minimalMode: boolean = false;
  @Input({ required: false }) customTemplate : TemplateRef<any>
  @Input() placeholder: string = 'Search';
  // Added by Amisha on 2026-07-17.
  // Reason: contractor registrations need a page-specific attribute dropdown class so the
  // long Janus attribute list can scroll and position like renewals without affecting other screens.
  @Input() attributePopoverClass = '';
  @Input({ required: false }) showAdvancedFilter: boolean = false;
  @Input({required:false}) local_storage_key : string = '';
  @ViewChildren('popovers') filterPopovers: QueryList<NgbPopover>;
  @ViewChild('fp', { static: false }) filterPopover: NgbPopover;
  private filtersChangedSubject2: Subject<
    SearchFilterBuilderOutput
  > = new Subject<SearchFilterBuilderOutput>();// added by priya 27-02-2026

  // added by Sanchit 02-03-2026
  @Input() externalFilterInputs: ItemSearchOptionField[] = [];
  @Output() filterChipRemoved = new EventEmitter<ItemSearchOptionField>();
  @Output() externalFilterInputsChange = new EventEmitter<ItemSearchOptionField[]>();
  @Input() compact = true;
  // end by Sanchit 02-03-2026
  // Code added by Sanchit start 02/27/2026
  @Input() myWorkOptions: myWorkOptions[] = []; // Added by Sanchit on 02/25/2026
  // Code added by Sanchit End 02/27/2026

  // params = [
  //   { id: 'applicationNumber', name: 'Application Number' },
  //   { id: 'status', name: 'Status' },
  //   { id: 'createdDate', name: 'Created Date' }
  // ];
  selectedFilter: any = null;

  // get filteredParams() {
  //   return this.params;
  // }
  get filteredParams() {
    return this.attributeOptions;
  }

  filters: FilterBuilderFilter[] = [];  // added by priya 27-02-2026
  searchModel: string;

  searchQuery: string = '';
  formData = {
    ParcelId: '',
    PropertyOwner: '',
    PropertyAddress: ''
  };

  getMyWorkLabel(item: ItemSearchOptionField): string {
    const match = this.myWorkOptions?.find(opt =>
      opt.value === item.title &&
      opt.searchText === item.options?.[0]?.searchText
    );

    return match?.name || item.title;
  }
  openAttributeDropdown(popover: NgbPopover) {
  this.showFilters(popover);
}

  isMyWorkChip(item: ItemSearchOptionField): boolean {
    return this.myWorkOptions?.some(opt =>
      opt.value === item.title &&
      opt.searchText === item.options?.[0]?.searchText
    );
  }
  // added by Sanchit 02-03-2026
  onFilterChipRemove(item: ItemSearchOptionField): void {
    const updatedFilters = this.externalFilterInputs.filter(f =>
      !(
        f.title === item.title &&
        f.options?.[0]?.filterText === item.options?.[0]?.filterText
      )
    );

    this.externalFilterInputsChange.emit(updatedFilters);
  }

  onMyWork(option: myWorkOptions) {

    const newField: ItemSearchOptionField = {
      title: option.value,
      options: [{
        title: option.value,
        selected: true,
        filterText: option.filterText ?? '',
        searchText: option.searchText,
        strOperator: option.strOperator ?? null
      }]
    };

    // 🔍 Check if already selected
    const exists = this.externalFilterInputs?.some(f =>
      f.title === option.value &&
      f.options?.[0]?.searchText === option.searchText
    );

    let updatedFilters: ItemSearchOptionField[];

    if (exists) {
      // Remove only that specific my work filter
      updatedFilters = this.externalFilterInputs.filter(f =>
        !(f.title === option.value &&
          f.options?.[0]?.searchText === option.searchText)
      );
    } else {
      // 🔥 IMPORTANT → Merge with existing filters
      updatedFilters = [
        ...(this.externalFilterInputs || []),
        newField
      ];
    }

    this.externalFilterInputsChange.emit(updatedFilters);
  }

  isMyWorkSelected(option: myWorkOptions): boolean {
    return this.externalFilterInputs?.some(f =>
      f.title === option.value &&
      f.options?.[0]?.searchText === option.searchText
    );
  }
  // end by Sanchit 02-03-2026

  onParcelIdChange(val: string) {
    this.formData.ParcelId = val;
  }
  onPropertyOwnerChange(val: string) {
    this.formData.PropertyOwner = val;
  }
  onPropertyAddressChange(val: string) {
    this.formData.PropertyAddress = val;
  }

  onAdvancedSearch() {
    // this.parcelId.emit(this.formData.ParcelId);
    // this.propertyAddress.emit(this.formData.PropertyAddress);
    // this.propertyOwner.emit(this.formData.PropertyOwner);
      this.workflowApplicationsJanusSvc.setData({
    ...this.workflowApplicationsJanusSvc.getData(),

    parcelId: this.formData.ParcelId,
    propertyOwner: this.formData.PropertyOwner,
    propertyAddress: this.formData.PropertyAddress
  });
    this.isAdvancedOpen = false;
  }
  isAdvancedOpen: boolean = false;
  searchFieldConfig = {
    label: '', // must be empty
    placeholder: 'Search',
    type: 'text',
    variant: 'outline',
    required: false,

    startIcon: {
      matIconName: 'search'
    },
      endIcon: {
    matIconName: '',
    onIconClick: () => {}
  }
  };
  private buildSearchFieldConfig() {
    // this.searchFieldConfig = {
    //   label: '',
    //   placeholder: this.placeholder,
    //   type: 'text',
    //   variant: 'outline',
    //   required: false,
    //   startIcon: {
    //     matIconName: 'search'
    //   },
    //   ...(this.showAdvancedFilter && {
    //     endIcon: {
    //       matIconName: 'tune',
    //       onIconClick: () => {
    //         this.isAdvancedOpen = !this.isAdvancedOpen;
    //       }
    //     }
    //   })
    // };
    this.searchFieldConfig = {
    label: '',
    placeholder: this.placeholder,
    type: 'text',
    variant: 'outline',
    required: false,

    startIcon: {
      matIconName: 'search'
    },

    endIcon: this.showAdvancedFilter
      ? {
          matIconName: 'tune',
          onIconClick: () => {
            this.isAdvancedOpen = !this.isAdvancedOpen;
          }
        }
      : {
          matIconName: '',
          onIconClick: () => {}
        }
  };
  }
  showAttributeOptions = false;
  showMyWorkOptions = false;
  showBulkOptions = false;
  @Input() attributeOptions: any[] = [];

  // attributeOptions = ['Type', 'Status', 'Expiry Date'];
  bulkOptions = ['Export', 'Delete', 'Disable'];

  // OUTPUT EVENTS (Parent Component will listen)
  @Output() search = new EventEmitter<ItemSearchOptionField[]>();
  @Output() parcelId = new EventEmitter<string>();
  @Output() propertyOwner = new EventEmitter<string>();
  @Output() propertyAddress = new EventEmitter<string>();
  @Output() attributeSelect = new EventEmitter<string>();
  // Fires when the attribute list or a filter chip is opened so parents can lazy-load option lists.
  @Output() attributeMenuOpened = new EventEmitter<void>();
  @Output() bulkSelect = new EventEmitter<string>();



  ngOnChanges(changes: SimpleChanges) {

  if (changes['placeholder'] || changes['showAdvancedFilter']) {
    this.buildSearchFieldConfig();
  }

if (changes['attributeOptions']) {

  const cache = localStorage.getItem(this.local_storage_key);

  if (!cache) {
    return;
  }

  const parsed = JSON.parse(cache);

  const hasWorkflowName = parsed?.attributeFilterInputs?.some(
    (f: any) => f.title === 'WORKFLOW_NAME'
  );

  // Added by Amisha on 2026-08-27.
  // Reason: changing the App Type operator temporarily clears its value, so the
  // in-progress WORKFLOW_NAME badge must not be removed during cache synchronization.
  const isEditingWorkflowName = this.filters.some(
    filter =>
      filter.param?.id === 'WORKFLOW_NAME' &&
      !!filter.queryType &&
      !filter.value
  );

  if (!hasWorkflowName && !isEditingWorkflowName) {
    this.filters = this.filters.filter(
      f => f.param?.id !== 'WORKFLOW_NAME'
    );

    this.simpleFilters = this.simpleFilters.filter(
      f => f.param?.id !== 'WORKFLOW_NAME'
    );
  }
}


  // 🔥 MAIN FIX — ADD HERE
  if (changes['attributeOptions'] && this.attributeOptions?.length) {

    const cached = this.getCachedFilters();
    if (cached?.length && !this.filters.length) {
      this.filters = cached;

      setTimeout(() => {

         if (this.isInitialLoad) {
          this.isInitialLoad = false;
          this.filtersChanged();

          return;
        }

        this.filtersChanged();
      });
    }
  }

  if (changes['attributeOptions'] && this.filters.length) {

  this.filters.forEach(filter => {

    const latest = this.attributeOptions.find(
      a => a.id === filter.param.id
    );

    if (latest) {
      filter.param = {
        ...filter.param,
        ...latest
      };
    }

  });

}

  if(changes['attributeOptions'] && this.attributeOptions?.length && this.local_storage_key  &&
  this.filters.length === 0){

    const cached = this.syncCachedAttributeFilters();
    if (cached?.length) {
      this.filters = cached;
      this.filtersChanged(true);
    }
  }
}

  // End code changes by Krutika
  onSearch() {
    const attributesId = this.attributeOptions.map((attribute) => attribute?.id)

    const simpleSearchFilterInputs: ItemSearchOptionField[] = attributesId.map((attributeId) => {
      return {
        title: attributeId,
        options: [
          new ItemSearchOptionFieldOption({
            title: attributeId,
            searchOptionMethod: 'simpleSearch',
            filterText: this.searchQuery
          })
        ]
      }
    })
    if(this.searchQuery === ''){
this.search.emit([]);
    }else{
      this.search.emit(simpleSearchFilterInputs);
    }

  }


  ngOnInit() {
    // Added by Amisha on 2026-06-16.
    // Reason: Janus pages such as Renewals pass their own placeholder text, so the search
    // field config must be rebuilt on init instead of briefly rendering the old hardcoded copy.
    this.buildSearchFieldConfig();

    // added by priya 27-02-2026

    if (this.useMuiLayout) {
this.updateDropdownHeight()
      const style = document.createElement('style');
      style.id = 'disable-popover-style';
      style.innerHTML = `
      ngb-popover-window {
        border: none !important;
        box-shadow: none !important;
            width: auto;
  height: auto;
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
  border-radius: 16px !important;
      }
    `;
      document.head.appendChild(style);
    }
    // end by priya 27-02-2026


  }



  handleSearchChange(value: string) {
    this.searchQuery = value;
    const attributesId = this.attributeOptions.map((attribute) => attribute?.id)

    const simpleSearchFilterInputs: ItemSearchOptionField[] = attributesId.map((attributeId) => {
      return {
        title: attributeId,
        options: [
          new ItemSearchOptionFieldOption({
            title: attributeId,
            searchOptionMethod: 'simpleSearch',
            filterText: value
          })
        ]
      }
    })



      if(value === ''){
this.search.emit([]);
      }else{
        this.search.emit(simpleSearchFilterInputs);
      }


  }

  toggleAttributeMenu(event: Event) {
    event.stopPropagation();
    this.closeAll();
    this.showAttributeOptions = !this.showAttributeOptions;
  }

  toggleMyWorkMenu(event: Event) {
    event.stopPropagation();
    this.closeAll();
    this.showMyWorkOptions = !this.showMyWorkOptions;
  }

  toggleBulkMenu(event: Event) {
    event.stopPropagation();
    this.closeAll();
    this.showBulkOptions = !this.showBulkOptions;
  }

  onAttributeSelect(option: string) {

    this.attributeSelect.emit(option);
    this.closeAll();
  }

  onBulkSelect(option: string) {
    this.bulkSelect.emit(option);
    this.closeAll();
  }

  closeAll() {
    this.showAttributeOptions = false;
    this.showMyWorkOptions = false;
    this.showBulkOptions = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this.isAdvancedOpen) return;

    const clickedInside = this.elementRef.nativeElement.contains(event.target);

    if (!clickedInside) {
      this.isAdvancedOpen = false;
    }
  }
  // added by priya 27-02-2026

  @Input() id: string;
  private filtersChangedSubject: Subject<FilterBuilderOutput> = new Subject<
    FilterBuilderOutput
  >();
  @Input() showFilterBuilder = true;

  defaultDateRangeOpts = [
    {
      name: 'Today',
      value: 'this_1_days'
    },
    {
      name: 'Yesterday',
      value: 'previous_1_day'
    },
    {
      name: 'Current Week',
      value: 'this_1_weeks'
    },
    {
      name: 'Previous Week',
      value: 'previous_1_weeks'
    },
    {
      name: 'Current Month',
      value: 'this_1_months'
    },
    {
      name: 'Last Month',
      value: 'previous_1_months'
    },
    {
      name: 'Current Calendar Quarter',
      value: 'this_1_calendarquarter'
    },
    {
      name: 'Previous Calendar Quarter',
      value: 'previous_1_calendarquarter'
    },
    {
      name: 'Current Year',
      value: 'this_1_years'
    },
    {
      name: 'Last Year',
      value: 'previous_1_years'
    },
    {
      name: 'Custom',
      value: 'custom'
    }
  ];
  openRangeMenu = false;
  openOptionMenu = false
  bypassBinding(f, e) {
    f.value = e.srcElement.value;
    this.filtersChanged();
  }
  onOptionSelect(filter, opt) {

    const fakeEvent = {
      srcElement: {
        value: opt.value
      }
    };


    this.bypassBinding(filter, fakeEvent);
    this.openOptionMenu = false

  }
  openFilter(popover: NgbPopover) {
    this.attributeMenuOpened.emit();
    this.openOptionMenu = false;
    this.openRangeMenu = false;

    this.filterPopovers.forEach(pop => {
      if (pop !== popover) {
        pop.close();
      }
    });
    this.filterPopover.close();
    popover.toggle();
  }
  dropdownHeight = 500;

  updateDropdownHeight() {
    const tableContainer = document.querySelector(
      '.common-table-container'
    ) as HTMLElement;

    // Added by Amisha on 2026-07-13.
    // Reason: the Janus filter range/options menu needs a viewport-safe height so it
    // stays scrollable on zoomed and smaller screen sizes without overflowing.
    const width = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const containerHeight = tableContainer?.getBoundingClientRect().height ?? viewportHeight;
    const availableHeight = Math.max(
      220,
      Math.min(680, containerHeight, viewportHeight - 140)
    );

    if (width <= 480) {
      this.dropdownHeight = 220;
    } else if (width <= 768) {
      this.dropdownHeight = 250;
    } else if (width <= 958) {
      this.dropdownHeight = 300;
    } else {
      this.dropdownHeight = availableHeight;
    }
  }
  toggleOptionMenu() {
    this.openOptionMenu = !this.openOptionMenu;

    if (this.openOptionMenu) {
      this.updateDropdownHeight();
    }
  }

  toggleRangeMenu() {
    this.openRangeMenu = !this.openRangeMenu;

    // Added by Amisha on 2026-07-13.
    // Reason: the Janus range dropdown should recalculate its height when opened so
    // the same responsive sizing used by the other option menus also applies here.
    if (this.openRangeMenu) {
      this.updateDropdownHeight();
    }
  }
  @Input() filterTypes = [
    {
      name: 'contains'
    },
    {
      name: 'is'
    },
    {
      name: 'in'
    },
    {
      name: 'range'
    }
  ];
  private filterTypeCache = new Map<string, any[]>();
  @Output() filterChanged = new EventEmitter<ItemSearchOptionField[]>();
  getFilterTypes(param: FilterBuilderParam) {
    if (!param) return [];

    // ✅ return from cache if exists
    if (this.filterTypeCache.has(param.id)) {
      return this.filterTypeCache.get(param.id)!;
    }

    let result: any[];

    // ✅ PRIORITY: explicit types
    if (param?.types?.length) {
      result = param.types.map(t => ({ name: t }));
    } else {
      let filterTypes = [...this.filterTypes];

      if (
        param.inputType !== 'date' &&
        param.inputType !== 'datetime-local' &&
        param.inputType !== 'text' &&
        param.inputType !== 'number'
      ) {
        filterTypes = filterTypes.filter(t => t.name !== 'range');
      }

      if (param.options == null) {
        filterTypes = filterTypes.filter(t => t.name !== 'in');
      }

      result = filterTypes;
    }

    // ✅ cache it (VERY IMPORTANT)
    this.filterTypeCache.set(param.id, result);

    return result;
  }
  getFilterDisplay(filter: FilterBuilderFilter): string {
    const label = filter.param?.name || '';

    // nothing selected yet
    if (!filter.queryType) {
      return label;
    }

    if (!filter.value) {
      return `${label} ${filter.queryType}`;
    }

    return `${label} ${filter.queryType} ${filter.value}`;
  }
  getSelectedRangeName(filter: any): string | null {
    const opt = this.getFilterRangeOptions(filter.param)
      .find(o => o.value === filter.value);
    return opt?.name || null;
  }
  getSelectedOptionName(filter: any): string | null {
    const opt = this.getFilterOptions(filter.param)
      .find(o => o.value === filter.value);
    return opt?.name || null;

  }
  onDateRangeSelect(filter: any, opt: any): void {
    if (filter.value === opt.value) return;

    filter.value = opt.value;
    this.filtersChanged();

    this.openRangeMenu = false;
  }
  @ViewChild('filterBtn') filterBtn!: ElementRef;
   //added by priya on 20-08-2026
  //Restore the main container height when the Attribute filter is closed.
  restoreMainContainerHeight() {
  const mainContainer = document.querySelector(
    '.main-container'
  ) as HTMLElement | null;

  if (mainContainer) {
        mainContainer.style.height = '100lvh';

    mainContainer.style.width = '100svw';
  }
}
  dropdownMaxHeight=680
  showFilters(pop: NgbPopover) {
    this.attributeMenuOpened.emit();
    this.filterPopovers.forEach(p => {
      if (p !== pop) {
        p.close();
      }
    });
    //added by priya on 20-08-2026
    //Dynamically calculate the available space for the Attribute dropdown
// to prevent it from being cut off at the bottom of the viewport.
  const mainContainer = document.querySelector(
    '.main-container'
  ) as HTMLElement | null;

  if (mainContainer) {
    mainContainer.style.height = '100%';
        mainContainer.style.width = '100%';

  }


      const rect = this.filterBtn.nativeElement.getBoundingClientRect();

      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      this.dropdownMaxHeight = Math.max(
        200,
        Math.min(680, Math.max(spaceBelow, spaceAbove) - 30)
      );
      pop.placement = spaceBelow >= spaceAbove ? 'bottom' : 'top';

      pop.toggle();
    }

  isInLayout(filter: FilterBuilderFilter): boolean {
    if (!filter) return false;



    return filter.queryType === 'in' || filter.queryType === 'is';
  }
  addFilter(param: FilterBuilderParam) {
    const latestParam =
      this.attributeOptions?.find(p => p.id === param.id) || param;

    const filter = new FilterBuilderFilter({
      paramId: latestParam.id,
      param: latestParam,
      queryType: ''
    });

    this.filters.push(filter);
    this.filters = [...this.filters];

    setTimeout(() => {
      const popover = this.filterPopovers.find((p: any) => {
        return (
          p &&
          p._nativeElement &&
          p._nativeElement.id === `filter-${filter.id}`
        );
      });

      this.openFilter(popover);
    }, 10);
  }
  filterText(filter: FilterBuilderFilter) {
    if (filter.queryType === 'exists') {
      return 'exists';
    }

    if (filter.queryType === 'not exists') {
      return 'not exists';
    }

    if (filter.queryType === 'range') {
      if (filter.value && filter.value !== 'custom') {
        const range = this.defaultDateRangeOpts.find(
          opt => opt.value === filter.value
        );

        if (!range) {
          return '';
        }

        return range.name;
      }

      if (filter.customValue) {
        const transformFn = defaultTransforms[filter.param.inputType];

        let start = filter.customValue.start;
        let end = filter.customValue.end;

        if (transformFn) {
          start = transformFn(start);
          end = transformFn(end);
        } else {
          start = start || '(unset)';
          end = end || '(unset)';
        }
        return `from ${start} to ${end}`;
      }

      return '';
    } else if (filter.queryType === 'in' && Array.isArray(filter.customValue)) {
      const list = filter.customValue.map(value => {
        const tempFilter = Object.assign({}, filter);
        tempFilter.value = value;

        return this.transformFilterValue(tempFilter);
      });

      return `${filter.queryType} ${list.join(', ')}`;
    } else if (filter.queryType && filter.value) {
      let plainTextValue = this.transformFilterValue(filter);
      if(this.allowTransformFilterValue === false && filter?.param.id === 'WORKFLOW_NAME'){
 plainTextValue = filter?.value;
      }else {
 plainTextValue = this.transformFilterValue(filter);
      }


      return `${filter.queryType} ${plainTextValue}`;
    }
    return '';
  }
  simpleFilters: FilterBuilderFilter[] = [];
  private transformFilterValue(filter: FilterBuilderFilter): string {
    const optionsObject = {};
    if (filter.param.options) {
      for (const opt of filter.param.options) {
        if (typeof opt === 'object') {
          const optObject = opt as FilterBuilderParamOpt;
          optionsObject[optObject.value] = optObject.name;
        } else {
          optionsObject[opt] = opt;
        }
      }
    }

    if (filter.param.valueTransform) {
      return filter.param.valueTransform(filter.value);
    } else if (filter.param.options && filter.queryType !== 'contains') {
      return optionsObject[filter.value];
    } else if (defaultTransforms[filter.param.inputType]) {
      const transformFn = defaultTransforms[filter.param.inputType];
      return transformFn(filter.value);
    } else {
      return filter.value;
    }
  }
  getFilterRangeOptions(param: FilterBuilderParam): FilterBuilderParamOpt[] {
    return param.rangeOptions || this.defaultDateRangeOpts;
  }
  getFilterOptions(param: FilterBuilderParam): FilterBuilderParamOpt[] {

    return param.options.map(opt => {
      if (typeof opt === 'string') {
        return { name: opt, value: opt };
      } else {
        return opt as FilterBuilderParamOpt;
      }
    });
  }
  filtersChanged(dontEmit?:boolean) {

    let submissionFilter: FilterBuilderFilter[];
    let submissionFilter2: FilterBuilderFilter[];
    setTimeout(() => {
      const results = this.simpleFilters.filter(
        a =>
          !this.filters.some(b => {
            return a.param.id === b.param.id;
          })
      );

      submissionFilter = this.filters.concat(results);
      submissionFilter2 = this.filters.concat(this.simpleFilters);

      const filterOutputs: FilterBuilderOutput = {};
      const filterOutputs2: SearchFilterBuilderOutput = {};

      for (const filter of submissionFilter) {

        let value = filter.value;
        if (
          filter.queryType === 'range' &&
          (filter.value === 'custom' ||
            filter.param.inputType === 'text' ||
            filter.param.inputType == 'number') &&
          filter.customValue &&
          filter.customValue.start &&
          filter.customValue.end
        ) {
          value = JSON.stringify(filter.customValue);
        } else if (
          filter.queryType === 'range' &&
          (filter.value === 'custom' ||
            filter.param.inputType === 'text' ||
            filter.param.inputType == 'number')
        ) {
          value = null;
        } else if (
          filter.queryType === 'in' &&
          Array.isArray(filter.customValue)
        ) {
          value = filter.customValue.join(',');
        }

        // only use the filter if it actually is complete
        if (
          value ||
          filter.queryType == 'exists' ||
          filter.queryType == 'not exists'
        ) {
          filterOutputs[filter.param.id] = {
            id: filter.param.id,
            type: filter.queryType,
            searchOptionMethod: filter.searchOptionMethod,
            value,
            inputType: filter.param.inputType
          };
        }
      }

      for (const filter of submissionFilter2) {
        let value = filter.value;
        if (
          filter.queryType === 'range' &&
          (filter.value === 'custom' ||
            filter.param.inputType === 'text' ||
            filter.param.inputType == 'number') &&
          filter.customValue &&
          filter.customValue.start &&
          filter.customValue.end
        ) {
          value = JSON.stringify(filter.customValue);
        } else if (
          filter.queryType === 'range' &&
          (filter.value === 'custom' ||
            filter.param.inputType === 'text' ||
            filter.param.inputType == 'number')
        ) {
          // if it is a custom date range that hasn't been set yet, make value null
          value = null;
        } else if (
          filter.queryType === 'in' &&
          Array.isArray(filter.customValue)
        ) {
          value = filter.customValue.join(',');
        }
        if (
          value ||
          filter.queryType == 'exists' ||
          filter.queryType == 'not exists'
        ) {
          filterOutputs2[filter.param.id] =
            filter.param.id in filterOutputs2
              ? filterOutputs2[filter.param.id]
              : [];
          filterOutputs2[filter.param.id].push({
            id: filter.param.id,
            type: filter.queryType,
            searchOptionMethod: filter.searchOptionMethod,
            value,
            inputType: filter.param.inputType
          });
        }
      }
      this.setCachedFilters(this.filters);

      const mappedFilters: ItemSearchOptionField[] = Object.entries(
        filterOutputs2
      ).map(([field, opts]) => ({
        title: field,
        options: (opts || []).map(
          opt => {
            // Range filters must route the value into `searchText` (not `filterText`) so the server's
            // date-range branch (which reads `option.searchText` and calls `GetUtcDateRange` on it)
            // receives the preset token (e.g. "this_1_weeks") instead of an empty string. Previously
            // the janus emit put range values into `filterText`, which caused SearchInspectionsJanus
            // and any other endpoint that doesn't first promote filterText->searchText to NRE inside
            // GetUtcDateRange.
            //
            // Contractors-janus and renewals-janus already unconditionally promote filterText into
            // searchText in their own buildFilters() shims, so the range case happened to work for
            // them; other janus consumers (inspections, workflow-view-details, workflow-applications)
            // have no such shim and were affected. All non-range cases (contains/is/in/empty) are
            // left exactly as before to avoid changing behavior for those consumers.
            const rawValue = opt.value ?? '';
            const type = (opt.type ?? '').toLowerCase();
            const isRange = type === 'range';

            return new ItemSearchOptionFieldOption({
              title: field,
              selected: true,
              filterText: isRange ? '' : rawValue,
              searchText: isRange ? rawValue : '',
              strOperator: opt.type ?? '',
              searchOptionMethod: opt.searchOptionMethod,
              inputType: opt.inputType
            });
          }
        )
      }));

      this.filtersChangedSubject2.next(filterOutputs2);
      this.filtersChangedSubject.next(filterOutputs);
      if(dontEmit === true)return;
      this.filterChanged.emit(mappedFilters);
    },);
  }

  private setCachedFilters(filters: FilterBuilderFilter[]) {
    if (!this.id) {
      return;
    }


    const flattenedFilters = filters.map(filter => filter.flatten());

    const stringData = JSON.stringify(flattenedFilters);
    localStorage.setItem(this.cacheId, stringData);
  }

    private syncCachedAttributeFilters(): FilterBuilderFilter[] {
  const cache = localStorage.getItem(this.local_storage_key);

  if (!cache) return [];
  if(cache){
    try {
      const parsed = JSON.parse(cache);
      return parsed.attributeFilterInputs.map(f => {
      const param = this.attributeOptions?.find(
  p => String(p.id) === String(f.options[0].title)
);

      if (!param) return null;

let filterBuilderFilter = new FilterBuilderFilter({
        ...f,
        param
      });
      filterBuilderFilter.value = f.options[0].filterText;



filterBuilderFilter.queryType = f.options[0].strOperator;


      return filterBuilderFilter
    }).filter(f => f !== null);
    } catch (error) {
      return [];
    }
  }
}
// code added by Krutika

  private getCachedFilters(): FilterBuilderFilter[] {
  if (!this.id) return [];

  const data = localStorage.getItem(this.cacheId);
  if (!data) return [];

  try {
    const parsed = JSON.parse(data);

    return parsed.map(f => {
      const param = this.attributeOptions?.find(p => p.id === f.paramId);

      if (!param) return null;

      return new FilterBuilderFilter({
        ...f,
        param
      });
    }).filter(f => f !== null);

  } catch {
    return [];
  }
}

// End code by Krutika


  get cacheId(): string {
    return `filter-builder-${this.id}`;
  }

  removeFilter(filter: FilterBuilderFilter) {
    this.filters = this.filters.filter(f => f.id !== filter.id);
    this.filtersChanged();

  }
  onRemoveFilter(event: MouseEvent, filter: FilterBuilderFilter): void {
    event.stopPropagation();
    this.removeFilter(filter);
  }
  changeFilterType(filter: FilterBuilderFilter) {
    filter.value = null;
    filter.customValue = {};

    this.filtersChanged();
  }
  getSelectedOptionInQuery(filter) {

    const selectedValues = String(filter.value || '')
    .split(',')
    .filter(Boolean);

  return this.getFilterOptions(filter.param)
    .filter(opt => selectedValues.includes(opt.value))
    .map(opt => opt.name)
    .join(', ');

    }
    isSelected(filter, value) {
      const selected =
        Array.isArray(filter.customValue) &&
        filter.customValue.includes(value);
      return selected;
    }
    onOptionInSelect(filter, opt) {

      let selected = Array.isArray(filter.customValue)
        ? [...filter.customValue]
        : [];

      const index = selected.indexOf(opt.value);

      if (index > -1) {
        selected.splice(index, 1);
      } else {
        selected.push(opt.value);
      }

      filter.customValue = selected;
      filter.value = selected.join(',');

      this.filtersChanged();

      // Added by Amisha on 2026-08-27.
      // Reason: close the App Type nested list after a selection while preserving
      // the existing open multi-select behavior for all other `in` filters.
      if (filter.param?.id === 'WORKFLOW_NAME') {
        this.openOptionMenu = false;
      }
    }
  // end by priya 27-02-2026

  styleMyWork(): void {
  setTimeout(() => {
    const panels = document.querySelectorAll('.mat-mdc-menu-panel');

    const panel = panels[panels.length - 1] as HTMLElement;

    if (panel) {
      panel.style.minWidth = '200px';
      panel.style.borderRadius = '16px';
      panel.style.marginTop = '8px';
      panel.style.overflow = 'hidden';
    }
  });
}

}
